// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"6d53a835","209":"6d53a835","636":"6d53a835","838":"32e88da9","913":"6d53a835"}[chunkId] + ".chunk.css";
};